import { Component, HostBinding, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { CoreService } from '@portal-client/core/core.service';
import { Observable, map } from 'rxjs';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'mc-app-full-navbar-heading',
    templateUrl: './app-full-navbar-heading.component.html',
    styleUrls: ['./app-full-navbar-heading.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatTabNav, MatTabLink, RouterLink, MatTabNavPanel, AsyncPipe]
})
export class AppFullNavbarHeadingComponent implements OnInit {
  private readonly coreService = inject(CoreService);

  @HostBinding('class.mc-navbar-heading-logo') navbarHeadingLogoClass: boolean = true;

  routerLinkCommand$: Observable<(string | number)[]>;

  ngOnInit() {
    this.routerLinkCommand$ = this.coreService.getActiveLicense$().pipe(
      map(license => license ? ['/', license.Id] : ['/']),
    );
  }
}
